module.exports = __webpack_public_path__ + "static/img/pexels-danxavier-1121796.d0781d7.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/pexels-danxavier-1121796.webp
// module id = SWN8
// module chunks = 0